import {
  Alert,
  AlertTitle,
  Box,
  type SxProps,
  type Theme,
} from "@mui/material";
import { memo } from "react";
import { type TenediFieldChangeFieldsFragment } from "../../../generated/graphql";
import { changeFieldLabel, changeValueLabel } from "../tenedi-connection-copy";

const styles = {
  list: { m: 0, pl: 2 } satisfies SxProps<Theme>,
};

export type ChangeSummaryValue = {
  readonly title: string;
  readonly scope: "carrier" | "customer" | "partnership";
  readonly changes: readonly TenediFieldChangeFieldsFragment[];
};

type ChangeSummaryProps = {
  readonly summary: ChangeSummaryValue;
  readonly onClose: () => void;
};

/** What the last save changed, old to new, as the server read it back. */
const ChangeSummary = memo(({ summary, onClose }: ChangeSummaryProps) => (
  <Alert severity="success" onClose={onClose}>
    <AlertTitle>{summary.title}</AlertTitle>
    {summary.changes.length === 0 ? (
      "Nothing changed."
    ) : (
      <Box component="ul" sx={styles.list}>
        {summary.changes.map((change) => (
          <li key={change.field}>
            {changeFieldLabel(change.field, summary.scope)}:{" "}
            {changeValueLabel(change.before)} to{" "}
            {changeValueLabel(change.after)}
          </li>
        ))}
      </Box>
    )}
  </Alert>
));
ChangeSummary.displayName = "ChangeSummary";

export default ChangeSummary;
